export default __webpack_public_path__ + "static/media/profile2.1e01ea25.jpg";